module.exports = __webpack_public_path__ + "static/events-container-panel-cc3b7d553283648ff0dc48c431a657e0.jpg";